import { Pipe, PipeTransform } from '@angular/core';
import { Opcion, OpcionCheckeable } from '../../infrastructure/services/selects.service';

@Pipe({name: 'toMultipleSelect'})
export class ToMultipleSelectPipe implements PipeTransform {
  transform(items: Opcion[], seleccionados: any[], campoId: string): OpcionCheckeable[] {

    if (!items || !seleccionados) {
      return items.map(item => ({
          id: item.codigo,
          descripcion: item.descripcion,
          seleccionado: false,
      }));
    }

    return items.map(item => {
      const opcionCheckeable: OpcionCheckeable = {
        id: item.codigo,
        descripcion: item.descripcion,
        seleccionado: false,
      };

      const existe = seleccionados.find(elem => {
        if (campoId) {
          // tslint:disable-next-line:triple-equals
          return item.codigo == elem[campoId];
        }

        // tslint:disable-next-line:triple-equals
        return item.codigo == elem;
      });

      if (existe) {
        opcionCheckeable.seleccionado = true;
      }

      return opcionCheckeable;
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/pipes/toMultipleSelect.pipe.ts